import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {InformType} from '../../global/util/enum/InformType';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-inform',
  templateUrl: './inform.component.html',
  styleUrls: ['./inform.component.css']
})
export class InformComponent implements OnInit {
  private informType: InformType;
  public informCodeDesc: string;
  public title: string;
  public iconClass = 'fa-2x fas ';
  public iconClassTitle = 'fa-2x fas ';
  public message: string;
  public modalHeight: number;

  constructor(public activeModal: NgbActiveModal,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.selectMessageInform(this.informType);
  }

  accept(): void {
    this.activeModal.close('accepted');
  }

  private selectMessageInform(informType: InformType) {
    switch (informType) {
      case InformType.Success:
        this.informCodeDesc = 'success';
        if (this.message === undefined) {
          this.message = this.translate.instant('MESSAGE.THE-OPERATION-WAS-SUCCESSFULLY-COMPLETED');
        }
        this.iconClass += 'fa-info-circle text-success';
        this.iconClassTitle += 'fa-check';
        break;
      case InformType.Info:
        this.informCodeDesc = 'info';
        if (this.message === undefined) {
          this.message = this.translate.instant('MESSAGE.NO-RECORDS-AVAILABLE');
        }
        this.iconClass += 'fa-info-circle text-info';
        this.iconClassTitle += 'fa-info-circle';
        break;
      case InformType.Warning:
        this.informCodeDesc = 'warning';
        if (this.message === undefined) {
          this.message = this.translate.instant('MESSAGE.REGISTRATION-ALREADY-EXISTS-IN-THE-SYSTEM');
        }
        this.iconClass += 'fa-exclamation-triangle text-warning';
        this.iconClassTitle += 'fa-exclamation-triangle';
        break;
      case InformType.Danger:
        this.informCodeDesc = 'danger';
        if (this.message === undefined) {
          this.message = this.translate.instant('MESSAGE.THE-REQUESTED-OPERATION-WAS-NOT-COMPLETED');
        }
        this.iconClass += 'fa-exclamation-circle text-danger';
        this.iconClassTitle += 'fa-times';
        break;
    }
  }

  get customStyleModal(): string {
    if (this.modalHeight) {
      return 'height: ' + this.modalHeight + 'px;';
    }
  }
}
